import VaultBalanceComponent from './vault_balance.component';

let vaultBalanceModule = angular.module('vaultBalance', [])

    .config(($stateProvider, $urlRouterProvider) => {
        "ngInject";

        $urlRouterProvider.otherwise('/vault-balance');

        $stateProvider
            .state('vaultBalance', {
                url: '/vault-balance',
                component: 'vaultBalance',
                data: {
                    requireLogin: true,
                    requireACL: 'vault_balance.all'
                },
                parent: 'app'
            });
    })

    .component('vaultBalance', VaultBalanceComponent)

    .name;

export default vaultBalanceModule;




// WEBPACK FOOTER //
// ./client/app/components/vault_balance/index.js